// extracted by mini-css-extract-plugin
var _1 = "ra-artist-banner-main";
var _2 = "ra-artist-bio-aside";
var _3 = "ra-artist-bio";
var _4 = "ra-artist-bio-content";
var _5 = "ra-artist-bio-content-main";
var _6 = "ra-artist-bio-description";
var _7 = "ra-artist-bio-left";
var _8 = "ra-artist-bio-name";
var _9 = "ra-artist-bio-name-extra-long";
var _a = "ra-artist-bio-name-long";
var _b = "ra-artist-bio-name-very-long";
var _c = "ra-artist-bio-right";
var _d = "ra-artist-bio-section";
var _e = "30";
export { _1 as "artistBannerMainCls", _2 as "artistBioAsideCls", _3 as "artistBioCls", _4 as "artistBioContentCls", _5 as "artistBioContentMainCls", _6 as "artistBioDescriptionCls", _7 as "artistBioLeftCls", _8 as "artistBioNameCls", _9 as "artistBioNameExtraLongCls", _a as "artistBioNameLongCls", _b as "artistBioNameVeryLongCls", _c as "artistBioRightCls", _d as "artistBioSectionCls", _e as "menuVerticalMargin" }
